module.exports = __webpack_public_path__ + "img/1-backgroundFour.d3d56fbc.png";